import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ChangeContentProvider from './context/contentContext';
import AppLoadGate from "./components/appLoadGate";
import SignIn from "./pages/signin";
import UserManagement from "./pages/usermanagement/userMange";
import AddUser from "./pages/usermanagement/addUser";
import EditUser from "./pages/usermanagement/editUser";
import ViewUser from "./pages/usermanagement/viewUser";
import AppConfig from "./pages/settings/appConfig";
import Profile from "./pages/profile";
import Client from "./pages/clientmanagement/client"
import EditClient from "./pages/clientmanagement/editclient"
import ViewClient from "./pages/clientmanagement/viewClient"
import NotFound from "./pages/NotFound";
import GeneratePassword from "./pages/pwdGenerate";
import StoreManage from "./pages/storemanagement/storeManage";
import DashBoard from "./pages/dashboard/dashboard";
import VerifyAccount from "./pages/verifyAccount";
import SignUp from "./pages/signUp";
import Request from "./pages/request";
import EditStore from "./pages/storemanagement/editStore";
import SwaggerComponent from "./pages/Swagger";
import Category from "./pages/categorymanagement/category";
import ClientUserList from "./pages/clientUsermanagement/userList";
import ClientUserDetails from "./pages/clientUsermanagement/userDetails";
import ViewClientUser from "./pages/clientUsermanagement/viewClientUser";
import SpotsManage from "./pages/Spots/spotsmanage";
import BusinessProfile from "./pages/businessProfile";
import Spots from "./pages/Spots/spots";
import UpgradePage from "./pages/upgrade";
import Subscriptions from "./pages/subscriptions/subcription";
import EditSubscriptions from "./pages/subscriptions/editSubscriptions";
import SubscriptionPlan from "./pages/subscriptions/subscriptionplan";
import PaymentPage from "./pages/subscriptions/PaymentPage";
import Transactions from "./pages/Transactions";
import Scan from "./pages/scan/scan";
import Notification from "./pages/alerts"
import BookingScreen from "./pages/BookingScreen";
import Spotpoc from "./pages/Spots/spotspoc"
import ReadNotification from "./pages/readNotification";
import DeleteAccount from "./pages/DeleteAccount";
import MyTransactions from "./pages/myTransactions";
import Payouts from "./pages/payouts";
import ContactSupport from "./pages/contactSupport";
import Unsubscribe from "./pages/Unsubscribe";
import ConnectBankAccount from "./pages/stripe/ConnectBankAccount";
import StripeOnboardingReturn from "./pages/stripe/StripeOnboardingReturn";
import StripeOnboardingRefresh from "./pages/stripe/StripeOnboardingRefresh";

function App() {
  // Empty dependency array = run once on component mount
  return (
    <BrowserRouter>
      <AppLoadGate>
        <ChangeContentProvider>
          <Routes>
            <Route path="/" element={<SignUp />} />
            <Route path="/signin" element={<SignIn />} />
            <Route path="/signin/:id" element={<SignIn />} />
            {/* <Route path="/createpassword" element={<CreatePassword />} /> */}
            <Route path="/login" element={<SignIn />} />
            <Route path="/users" element={<UserManagement />} />
            <Route path="/scan" element={<Scan />} />
            <Route path="/proUsers" element={<ClientUserList />} />
            <Route path="/proadduser" element={<ClientUserDetails />} />
            <Route path="/proedituser/:id" element={<ClientUserDetails />} />
            <Route path="/viewprouser/:id" element={<ViewClientUser />} />
            <Route path="/spots" element={<Spots />} />
            <Route path="/upgradeplan" element={<UpgradePage />} />
            <Route path="/transactions" element={<Transactions />} />
            <Route path="/subscriptions" element={<Subscriptions />} />
            <Route path="/addsubscription" element={<EditSubscriptions />} />
            <Route path="/subscription" element={<SubscriptionPlan />} />
            <Route path="/payment" element={<PaymentPage />} />
            <Route path="/spotsmanage/:id" element={<SpotsManage />} />
            <Route path="/businessprofile" element={<BusinessProfile />} />
            <Route path="/createuser" element={<AddUser />} />
            <Route path="/adduser" element={<EditUser />} />
            <Route path="/edituser/:id" element={<EditUser />} />
            <Route path="/viewuser/:id" element={<ViewUser />} />
            <Route path="/categories" element={<Category />} />
            <Route path="/poc" element={<Spotpoc />} />
         
            <Route path="/settings/:id" element={<AppConfig />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/deleteAccount" element={<DeleteAccount />} />
            <Route path="/unsubscribe" element={<Unsubscribe />} />
            <Route path="*" element={<NotFound />} />
          
            <Route path="/mytransactions" element={<MyTransactions/>} />
            <Route path="/payouts" element={<Payouts/>} />
            <Route path="/contactsupport" element={<ContactSupport/>} />
            <Route path="/verifyaccount" element={<VerifyAccount />} />
            <Route path="/thankyou" element={<Request />} />
            <Route path="/dashboard" element={<DashBoard />} />
            <Route path="/locations" element={<StoreManage />} />
            <Route path="/generatepwd" element={<GeneratePassword />} />
            <Route path="/clients" element={<Client />} />
            <Route path="/editclient/:id" element={<EditClient />} />
            <Route path="/viewclient/:id" element={<ViewClient />} />
            <Route path="/addclient" element={<EditClient />} />
            {/* <Route path="/adminlogin" element={<AdminLogin />} /> */}
            <Route path="/addstore"element={<EditStore />}/>
            <Route path="/editstore/:id"element={<EditStore />}/>
            <Route path="/swagger"element={<SwaggerComponent />}/>
            <Route path="/alerts"element={<Notification />}/>
            <Route path="/readnotification/:id"element={<ReadNotification />}/>
            <Route path="/BookingScreen/:id"element={<BookingScreen />}/>
            <Route path="/connectbankaccount" element={<ConnectBankAccount />} />
            <Route path="/stripe/onboarding/complete" element={<StripeOnboardingReturn />} />
            <Route path="/stripe/onboarding/refresh" element={<StripeOnboardingRefresh />} />
          </Routes>
        </ChangeContentProvider>
      </AppLoadGate>
    </BrowserRouter>
  );
}

export default App;

